export default "__VITE_ASSET__BYKumAig__"